import { useQuery } from '@tanstack/react-query';
import { DAYS_TO_MS, MINUTES_TO_MS } from '@utils/constants';
import { getCloudEntryByComponentEntryId } from './request.get-cloud-entries.js';

const getCloudEntriesQueryKey = componentEntryId => ["component-framework/get-cloud-entries", componentEntryId];
const getCloudEntriesQuery = componentEntryId => {
  return {
    queryKey: getCloudEntriesQueryKey(componentEntryId),
    queryFn: () => getCloudEntryByComponentEntryId(componentEntryId),
    staleTime: 15 * MINUTES_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true,
      revalidateOnRefresh: true
    }
  };
};
const useGetCloudEntriesQuery = (componentEntryId, extraConfig) => {
  return useQuery({
    ...getCloudEntriesQuery(componentEntryId),
    ...extraConfig
  });
};

export { getCloudEntriesQuery, getCloudEntriesQueryKey, useGetCloudEntriesQuery };
//# sourceMappingURL=query.get-cloud-entries.js.map
